/** The clinic's word for the people it treats, in the four forms UI text needs. */
export type SubjectLanguageVariants = {
  singular: string;
  singularCap: string;
  plural: string;
  pluralCap: string;
};

export const DEFAULT_SUBJECT_LANGUAGE: SubjectLanguageVariants = {
  singular: 'patient',
  singularCap: 'Patient',
  plural: 'patients',
  pluralCap: 'Patients',
};

const SUBJECT_WORD = /\b(Patients|patients|Patient|patient)\b/g;

/**
 * Guide titles are authored for a practice that says "patient". A clinic that
 * says "client" reads the link with its own word: whole words only, so
 * "inpatient" and "outpatient" stay as written.
 */
export function applySubjectLanguage(text: string, variants: SubjectLanguageVariants): string {
  if (variants.singular === DEFAULT_SUBJECT_LANGUAGE.singular) return text;
  return text.replace(SUBJECT_WORD, word => {
    switch (word) {
      case 'Patients':
        return variants.pluralCap;
      case 'patients':
        return variants.plural;
      case 'Patient':
        return variants.singularCap;
      default:
        return variants.singular;
    }
  });
}
